(() => {
  'use strict';
  const root=document.querySelector('#gw-childrens-guide');
  if(!root) return;
  const tabs=[...root.querySelectorAll('.gw-tab')];
  const panels=[...root.querySelectorAll('.gw-panel')];
  const tabList=root.querySelector('.gw-tabs');
  const visited=new Set();
  function updateOffset(){
    const header=document.querySelector('.section-header');
    const height=header?header.getBoundingClientRect().height:70;
    root.style.setProperty('--gw-offset',`${Math.ceil(height)+20}px`);
  }
  updateOffset();
  window.addEventListener('resize',updateOffset,{passive:true});
  function selectGroup(index,{direct=false,focus=false,userInitiated=false}={}){
    tabs.forEach((t,i)=>{t.setAttribute('aria-selected',String(i===index));t.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;});
    if(!visited.has(index)){
      if(!direct){const first=panels[index].querySelector('details');if(first)first.open=true;}
      visited.add(index);
    }
    if(userInitiated){
      let target;try{target=document.getElementById(decodeURIComponent(location.hash.slice(1)));}catch{}
      // Keep a useful game-specific fragment while its group remains active.
      if(target?.closest('.gw-panel')!==panels[index]){
        const url=new URL(location.href);url.hash=panels[index].id;
        history.replaceState(history.state,'',url.href);
      }
    }
    if(focus)tabs[index].focus();
  }
  function resolveHash({focus=false,scroll=true}={}){
    let id;try{id=decodeURIComponent(location.hash.slice(1));}catch{return;}
    if(!id)return;
    const target=document.getElementById(id);
    if(!target||!root.contains(target))return;
    const panel=target.closest('.gw-panel');
    if(panel)selectGroup(panels.indexOf(panel),{direct:!!target.closest('details')});
    const detail=target.closest('details');if(detail)detail.open=true;
    requestAnimationFrame(()=>{
      if(scroll)target.scrollIntoView({behavior:'auto',block:'start'});
      if(focus){
        if(!target.matches('summary,a,button,input'))target.setAttribute('tabindex','-1');
        target.focus({preventScroll:true});
      }
    });
  }
  panels.forEach((p,i)=>{p.setAttribute('role','tabpanel');p.setAttribute('aria-labelledby',tabs[i].id);});
  tabList.setAttribute('role','tablist');
  tabs.forEach((tab,i)=>{
    tab.setAttribute('role','tab');
    tab.addEventListener('click',()=>selectGroup(i,{userInitiated:true}));
    tab.addEventListener('keydown',e=>{
      let next=null;
      if(e.key==='ArrowRight')next=(i+1)%tabs.length;
      if(e.key==='ArrowLeft')next=(i-1+tabs.length)%tabs.length;
      if(e.key==='Home')next=0;
      if(e.key==='End')next=tabs.length-1;
      if(next!==null){e.preventDefault();selectGroup(next,{focus:true,userInitiated:true});}
    });
  });
  tabList.classList.add('is-ready');
  const initial=document.getElementById(location.hash.slice(1));
  const targetGroup=initial?.closest('.gw-panel');
  selectGroup(targetGroup?panels.indexOf(targetGroup):0,{direct:!!initial?.closest('details')});
  resolveHash();
  window.addEventListener('hashchange',()=>resolveHash({focus:true}));
  root.addEventListener('click',e=>{
    const link=e.target.closest('a[href^="#"]');
    if(link&&new URL(link.href).hash===location.hash){e.preventDefault();resolveHash({focus:true});}
  });

  // Signup: the form posts natively to Ecomail. This only adds the approved messages and blocks resubmission.
  const form=root.querySelector('form.gw-form');
  if(!form) return;
  const name=form.querySelector('#gw-name');
  const email=form.querySelector('#gw-email');
  const submit=form.querySelector('.gw-submit');
  const status=root.querySelector('#gw-form-status');
  const submitLabel=submit.textContent;
  let sending=false;
  form.noValidate=true;
  // type=email also accepts addresses without a dot in the domain, which Ecomail rejects.
  const emailValid=()=>email.validity.valid&&/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value);
  function mark(field,valid){
    field.setAttribute('aria-invalid',String(!valid));
    document.getElementById(field.getAttribute('aria-describedby')).hidden=valid;
    return valid;
  }
  function setSending(value){
    sending=value;
    form.setAttribute('aria-busy',String(value));
    submit.disabled=value;
    submit.textContent=value?'Odesílám…':submitLabel;
    status.textContent=value?'Odesílám…':'';
    // An empty first name is left out so updateExisting cannot erase a stored one.
    if(value&&!name.value)name.removeAttribute('name');else name.setAttribute('name','name');
  }
  form.addEventListener('submit',e=>{
    if(sending){e.preventDefault();return;}
    if(!mark(email,emailValid())){e.preventDefault();email.focus();return;}
    name.value=name.value.trim();
    setSending(true);
  });
  email.addEventListener('input',()=>{if(email.getAttribute('aria-invalid')==='true')mark(email,emailValid());});
  // Back from an Ecomail page can restore this page from the back/forward cache with the form still sending.
  window.addEventListener('pageshow',e=>{if(e.persisted)setSending(false);});
})();
